import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxTransferRegister = cashBoxRegister("CashBoxTransferRegister")
export default CashBoxTransferRegister
